/* Energyze blueprint runtime — reveal/counters/rings/carousels/slider + real cart adds */
(function(){
  var EZB_STAR='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>';
  var EZB_STARS5=EZB_STAR+EZB_STAR+EZB_STAR+EZB_STAR+EZB_STAR;
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){

    /* reveal on scroll */
    var reveals = document.querySelectorAll('.ezb .reveal');
    if('IntersectionObserver' in window){
      var ro = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); ro.unobserve(e.target);} }); },{threshold:.12});
      reveals.forEach(function(e){ ro.observe(e); });
    } else reveals.forEach(function(e){ e.classList.add('in'); });

    /* counting numbers */
    document.querySelectorAll('.ezb .rev-count[data-target]').forEach(function(c){
      var run = function(){
        var t = parseInt(c.dataset.target,10), t0=null, D=1800;
        (function tick(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/D,1), e=1-Math.pow(1-p,3);
          c.textContent = Math.round(t*e).toLocaleString('en-US')+'+';
          if(p<1) requestAnimationFrame(tick); })(performance.now());
        function tick(){}
      };
      var runner = function(){
        var t = parseInt(c.dataset.target,10), t0=null, D=1800;
        function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/D,1), e=1-Math.pow(1-p,3);
          c.textContent = Math.round(t*e).toLocaleString('en-US')+'+';
          if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      };
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es,o){ es.forEach(function(e){ if(e.isIntersecting){ runner(); o.disconnect(); } }); },{threshold:.4}).observe(c);
      } else runner();
    });

    /* percentage rings */
    var CIRC = 2*Math.PI*76;
    document.querySelectorAll('.ezb .pc-ring').forEach(function(ring){
      var runner = function(){
        var pct = parseInt(ring.dataset.pct,10);
        var bar = ring.querySelector('.bar'), num = ring.querySelector('.pc-num');
        if(bar) bar.style.strokeDashoffset = (CIRC*(1-pct/100)).toFixed(1);
        var t0=null, D=1600;
        function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/D,1), e=1-Math.pow(1-p,3);
          if(num) num.textContent = Math.round(pct*e)+'%';
          if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      };
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es,o){ es.forEach(function(e){ if(e.isIntersecting){ runner(); o.disconnect(); } }); },{threshold:.45}).observe(ring);
      } else runner();
    });

    /* nutrient bars */
    document.querySelectorAll('.ezb .nutribars').forEach(function(nb){
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es,o){ es.forEach(function(e){ if(e.isIntersecting){ nb.classList.add('nb-go'); o.disconnect(); } }); },{threshold:.25}).observe(nb);
      } else nb.classList.add('nb-go');
    });

    /* generic paged carousels: [data-ezb-carousel] with [data-ezb-prev/next], data-pages, data-interval */
    document.querySelectorAll('[data-ezb-carousel]').forEach(function(wrap){
      var track = wrap.querySelector('.ezb-track');
      if(!track) return;
      var pages = parseInt(wrap.dataset.pages||'0',10);
      var per = parseInt(wrap.dataset.per||'1',10);
      var idx = 0, timer = null;
      function stepW(){ var card = track.children[0]; return card ? (card.getBoundingClientRect().width+16)*per : 340; }
      function goTo(i){ idx=(i+pages)%pages; track.scrollTo({left: idx*stepW(), behavior:'smooth'}); }
      wrap.querySelectorAll('[data-ezb-prev]').forEach(function(b){ b.addEventListener('click',function(){ goTo(idx-1); clearInterval(timer); timer=null; }); });
      wrap.querySelectorAll('[data-ezb-next]').forEach(function(b){ b.addEventListener('click',function(){ goTo(idx+1); clearInterval(timer); timer=null; }); });
      var iv = parseInt(wrap.dataset.interval||'0',10);
      if(iv>0) timer = setInterval(function(){ goTo(idx+1); }, iv);
    });

    /* hero angle slider */
    document.querySelectorAll('[data-ezb-hero]').forEach(function(hero){
      var slides = hero.querySelectorAll('.hero-slides img');
      var dotsWrap = hero.querySelector('.hero-dots');
      var h1 = hero.querySelector('[data-hero-h1]');
      var rev = hero.querySelector('[data-hero-review]');
      var data = [];
      try{ data = JSON.parse(hero.querySelector('[data-hero-json]').textContent); }catch(e){}
      if(!slides.length) return;
      var idx=0, timer;
      function show(i){
        idx=i;
        slides.forEach(function(s,j){ s.classList.toggle('on', j===i); });
        if(dotsWrap) dotsWrap.querySelectorAll('button').forEach(function(d,j){ d.classList.toggle('on', j===i); });
        var a = data[i]; if(!a) return;
        if(h1){ h1.style.opacity=0; setTimeout(function(){ h1.innerHTML=a.h1; h1.style.opacity=1; },350); }
        if(rev){ rev.classList.add('fade'); setTimeout(function(){ rev.innerHTML='<span class="stars">'+EZB_STARS5+'</span><b>'+a.q+'</b>'+a.n; rev.classList.remove('fade'); },350); }
      }
      if(dotsWrap){ slides.forEach(function(_,i){ var b=document.createElement('button'); if(i===0)b.classList.add('on');
        b.addEventListener('click',function(){ show(i); restart(); }); dotsWrap.appendChild(b); }); }
      function next(){ show((idx+1)%slides.length); }
      function restart(){ clearInterval(timer); timer=setInterval(next,4500); }
      restart();
    });

    /* ---------- real cart adds + Eurus mini-cart refresh ---------- */
    function cartRefresh(){
      if(window.ezbCartAdded){ window.ezbCartAdded(); }
      else if(window.Alpine && Alpine.store){ var m=Alpine.store('xMiniCart');
        if(m&&m.reLoad)m.reLoad(); if(m&&m.openCart)m.openCart();
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      } else { window.location.href='/cart'; }
    }
    function cartAdd(items, btn){
      items = (items||[]).filter(function(it){ return it && it.id; });
      if(!items.length) return;
      var old = btn && btn.textContent;
      if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({items: items})
      }).then(function(r){
        if(btn){ btn.disabled=false; }
        if(r.status===422){ if(btn){ btn.textContent='Sold out'; setTimeout(function(){ btn.textContent=old; },2400); } return; }
        if(!r.ok) throw 0;
        if(btn){ btn.textContent=old; }
        cartRefresh();
      })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=old; } window.location.href='/cart'; });
    }
    window.ezbAtc = function(btn, variantId){ cartAdd([{id: parseInt(variantId,10), quantity: 1}], btn); };

    /* ==================== PDP ENGINE (flavored / original / supergreen / bundle) ==================== */
    var pdpRoot = document.querySelector('[data-ezb-pdp]');
    var CFG = {};
    if(pdpRoot){
      try{ CFG = JSON.parse(pdpRoot.querySelector('[data-ezb-config]').textContent); }catch(e){ CFG = {}; }
    }
    var FLAVORS = [
      {name:'Mango',      img:'https://cdn.shopify.com/s/files/1/0718/2309/7971/files/energyze-indian-moringa-flavored-100grams-1285088.png?v=1785061914', tag:'The bloat-beater'},
      {name:'Lemon',      img:'https://cdn.shopify.com/s/files/1/0718/2309/7971/files/energyze-indian-moringa-flavored-100grams-2192200.png?v=1785061915', tag:'The crisp reset'},
      {name:'Strawberry', img:'https://cdn.shopify.com/s/files/1/0718/2309/7971/files/energyze-indian-moringa-flavored-100grams-7000996.jpg?v=1785061914', tag:'The glow-getter'}
    ];
    var FLAV_PRICES = {1:29.99, 2:39.99, 3:49.97};
    var ORIG_PRICES = {1:19.99, 2:24.99, 3:29.99};
    var SG_PRICES   = {1:39.99, 2:59.99, 3:79.99};
    var BP_PRICES   = {1:50.00, 2:75.00, 3:100.00};
    var BOTTLE_PRICE = 11.99;

    /* ---- schema-driven overrides, read from the section's data-ezb-config ---- */
    var UI = (CFG && CFG.ui) || {};
    if(UI.flavors && UI.flavors.length){
      FLAVORS = UI.flavors.map(function(f, i){
        var d = FLAVORS[i] || {};
        return { name: f.name || d.name, img: f.img || d.img, tag: f.tag || d.tag };
      });
    }
    if(UI.bottlePrice !== undefined && UI.bottlePrice !== null && !isNaN(parseFloat(UI.bottlePrice))) BOTTLE_PRICE = parseFloat(UI.bottlePrice);
    function ezbApplyPrices(target, src){
      if(!src) return target;
      [1,2,3].forEach(function(n){
        var v = src[n] !== undefined ? src[n] : src[String(n)];
        if(v === undefined || v === null) return;
        var p = (typeof v === 'object') ? v.p : v;
        p = parseFloat(p);
        if(!isNaN(p)) target[n] = p;
      });
      return target;
    }
    if(UI.prices){
      ezbApplyPrices(FLAV_PRICES, UI.prices.flav);
      ezbApplyPrices(BP_PRICES,   UI.prices.bp);
    }
    function ezbLabel(tpl, n, fallback){
      if(!tpl) return fallback;
      return String(tpl).replace('{n}', n).replace('{s}', n > 1 ? 's' : '');
    }
    function fmt(n){ return n.toFixed(2) + ' USD'; }
    function variantForFlavor(name){
      var p = CFG.flavored || {};
      var vs = p.variants || [];
      var hit = null;
      vs.forEach(function(v){ if(!hit && v.title && v.title.toLowerCase().indexOf(name.toLowerCase())>-1) hit = v; });
      if(!hit && vs.length===1) hit = vs[0];           /* single-variant product */
      return hit ? hit.id : (p.id || null);
    }
    function drawerReady(){
      /* Forced false. This used to route adds into theme.js's in-memory drawer model
         instead of the real cart, and syncRealCart() then mirrored that model over the
         Shopify cart. Because the model persists in localStorage['ezb_cart'], anything
         stuck in it came back on every add and survived removal from the drawer, so
         customers saw phantom quantities they could not get rid of.
         ezb-cart.js renders the real Shopify cart, so every add posts to /cart/add.js
         via the fallback path below and the Shopify cart is the single source of truth. */
      return false;
    }
    window.ezbAddUnit = function(pid){
      if(drawerReady() && typeof window.cartAddUnit === 'function' && (pid==='bottle'||pid==='original'||pid==='supergreen'||pid==='flavored')){
        window.cartAddUnit(pid); return;
      }
      var c = CFG[pid];
      if(c && c.id){ cartAdd([{id:c.id, quantity:1}], null); }
      else if(c && c.url){ window.location.href = c.url; }
    };

    /* galleries (DOM-driven) */
    window.ezbGalSet = function(page,i){
      var wrap = document.getElementById('galThumbs-'+page);
      var main = document.getElementById('galMain-'+page);
      if(!wrap || !main) return;
      var t = wrap.querySelectorAll('img');
      if(!t.length) return;
      i = ((i % t.length) + t.length) % t.length;
      main.src = t[i].src;
      t.forEach(function(im,j){ im.classList.toggle('on', j===i);
        if(j===i && im.scrollIntoView) im.scrollIntoView({block:'nearest', inline:'nearest'}); });
      wrap.dataset.idx = i;
    };
    window.ezbGalStep = function(page,d){
      var wrap = document.getElementById('galThumbs-'+page);
      if(!wrap) return;
      window.ezbGalSet(page, parseInt(wrap.dataset.idx||'0',10) + d);
    };

    /* flavor tabs — "The science, simply" */
    window.ezbFlavTab = function(name){
      document.querySelectorAll('.ezb .flav-panel').forEach(function(p){ p.classList.toggle('active', p.dataset.flavor===name); });
      document.querySelectorAll('.ezb .flav-tab').forEach(function(t){ t.classList.toggle('on', t.dataset.flavor===name); });
    };

    /* shared flavor-pick modal */
    var pickCtx = 'flav', flavModalSlot = 0, bpModalSlot = 0;
    function openModal(title, current){
      var tEl = document.getElementById('fmTitle'), sEl = document.getElementById('fmSub'), oEl = document.getElementById('fmOpts');
      if(!oEl) return;
      if(tEl) tEl.textContent = title;
      if(sEl) sEl.innerHTML = 'Pick <b>1 of 3</b> ('+(current?'1':'0')+'/1)';
      oEl.innerHTML = FLAVORS.map(function(fo){
        return '<div class="fm-opt'+(current===fo.name?' on':'')+'" onclick="ezbFlavChoose(\''+fo.name+'\')">'
          +'<img src="'+fo.img+'" alt="'+fo.name+'"><b>'+fo.name+'</b><small>'+fo.tag+'</small></div>';
      }).join('');
      document.body.classList.add('ezb-flav-picking');
    }
    window.ezbFlavClose = function(){ document.body.classList.remove('ezb-flav-picking'); };
    /* when a flavor is chosen, the product gallery switches to that flavor's image */
    function showFlavorImage(name){
      var fo = FLAVORS.filter(function(x){ return x.name===name; })[0];
      if(!fo) return;
      var main = document.getElementById('galMain-flavors') || document.getElementById('galMain-bundles');
      if(!main) return;
      main.src = fo.img;
      var wrap = document.getElementById('galThumbs-flavors') || document.getElementById('galThumbs-bundles');
      if(wrap) wrap.querySelectorAll('img').forEach(function(t){ t.classList.remove('on'); });
    }
    window.ezbFlavChoose = function(name){
      if(pickCtx==='bp'){ bSlots[bpModalSlot] = name; window.ezbFlavClose(); renderBpSlots(); showFlavorImage(name); return; }
      flavSlots[flavModalSlot] = name;
      window.ezbFlavClose();
      renderFlavSlots();
      showFlavorImage(name);
    };
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') window.ezbFlavClose(); });

    function tierFromDom(container){
      var tiers = container ? container.querySelectorAll('.tier') : [];
      var n = 0;
      tiers.forEach(function(t,i){ if(t.classList.contains('on')) n = i+1; });
      return n || 1;
    }

    /* ----- FLAVORED PDP ----- */
    var flavTier = 3, flavSlots = [null,null,null];
    var flavBox = document.getElementById('flavSlots');
    if(flavBox) flavTier = tierFromDom(flavBox.closest('.bb'));
    window.ezbFlavTier = function(el,n){
      flavTier = n;
      el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
      el.classList.add('on');
      renderFlavSlots();
    };
    window.ezbFlavSlot = function(i){
      pickCtx = 'flav'; flavModalSlot = i;
      openModal('Select your flavor — Slot '+(i+1), flavSlots[i]);
    };
    function renderFlavSlots(){
      var wrap = document.getElementById('flavSlots');
      if(!wrap) return;
      wrap.querySelectorAll('.slot').forEach(function(s,i){
        s.style.display = i < flavTier ? 'flex' : 'none';
        var f = flavSlots[i];
        if(f){
          var fo = FLAVORS.filter(function(x){ return x.name===f; })[0];
          s.classList.add('filled');
          s.innerHTML = '<img style="width:52px;height:52px;border-radius:11px;object-fit:cover" src="'+fo.img+'" alt="'+f+'"><b>'+f+'</b><span class="slot-progress">1/1 ✓ · tap to change</span>';
        } else {
          s.classList.remove('filled');
          s.innerHTML = '<span class="plus">+</span><span style="font-size:.72rem">Select your flavor</span><span class="slot-progress" style="color:var(--text)">0/1</span>';
        }
      });
      var filled = flavSlots.slice(0,flavTier).filter(Boolean).length;
      var btn = document.getElementById('flavAtc');
      if(!btn) return;
      if(filled < flavTier){ btn.disabled = true; btn.textContent = ezbLabel(UI.atcSelect, flavTier, 'Select your flavors')+' ('+filled+'/'+flavTier+')'; }
      else {
        btn.disabled = false;
        var fb = document.getElementById('flavBumpChk');
        var extra = (fb && fb.checked) ? BOTTLE_PRICE : 0;
        btn.textContent = ezbLabel(UI.atcAdd, flavTier, 'Add '+flavTier+' to Cart')+' — '+fmt(FLAV_PRICES[flavTier] + extra);
      }
    }
    window.ezbFlavAtc = function(){
      var btn = document.getElementById('flavAtc');
      if(!btn || btn.disabled) return;
      var chosen = flavSlots.slice(0,flavTier);
      var fb = document.getElementById('flavBumpChk');
      if(drawerReady() && window.FLAV_PRICES){
        var t = window.FLAV_PRICES[flavTier];
        window.cart = window.cart.filter(function(l){ return l.id!=='flavored' || !l.fixed; });
        window.cart.push({key:'flavored-tier', id:'flavored', title:'Flavored Moringa',
          img:(window.IMG && window.IMG.flavored) || '',
          label:t.label+' · '+chosen.join(', '), flavors:chosen.slice(),
          qty:flavTier, minQty:flavTier, unit:t.p/flavTier, wasU:t.w?t.w/flavTier:null, total:t.p, fixed:true});
        if(fb && fb.checked && typeof window.cartAddUnit==='function') window.cartAddUnit('bottle');
        window.openCart(); window.renderCart();
        return;
      }
      var counts = {};
      chosen.forEach(function(f){ counts[f] = (counts[f]||0)+1; });
      var items = Object.keys(counts).map(function(f){ return {id: variantForFlavor(f), quantity: counts[f]}; });
      if(fb && fb.checked && CFG.bottle && CFG.bottle.id) items.push({id: CFG.bottle.id, quantity: 1});
      cartAdd(items, btn);
    };

    /* ----- ORIGINAL PDP ----- */
    var origTier = 2;
    var origBtn = document.getElementById('origAtc');
    if(origBtn){ origTier = tierFromDom(origBtn.closest('.bb') || pdpRoot); }
    function origUpdate(){
      var btn = document.getElementById('origAtc');
      if(!btn) return;
      var bump = document.getElementById('origBumpChk');
      btn.textContent = 'Add to Cart — ' + fmt(ORIG_PRICES[origTier] + (bump && bump.checked ? BOTTLE_PRICE : 0));
    }
    window.ezbOrigTier = function(el,n){
      origTier = n;
      el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
      el.classList.add('on');
      origUpdate();
    };
    window.ezbOrigAtc = function(){
      var btn = document.getElementById('origAtc');
      var bump = document.getElementById('origBumpChk');
      if(drawerReady() && window.ORIG_PRICES){
        var t = window.ORIG_PRICES[origTier];
        window.cart = window.cart.filter(function(l){ return l.id!=='original' || !l.fixed || l.bundle; });
        window.cart.push({key:'original-tier', id:'original', title:'Original Powder',
          img:(window.IMG && window.IMG.original) || '', label:t.label,
          qty:origTier, minQty:origTier, unit:t.p/origTier, wasU:t.w?t.w/origTier:null, total:t.p, fixed:true});
        if(bump && bump.checked && typeof window.cartAddUnit==='function') window.cartAddUnit('bottle');
        window.openCart(); window.renderCart();
        return;
      }
      var items = [{id: CFG.original && CFG.original.id, quantity: origTier}];
      if(bump && bump.checked && CFG.bottle && CFG.bottle.id) items.push({id: CFG.bottle.id, quantity: 1});
      cartAdd(items, btn);
    };

    /* ----- SUPERGREEN PDP ----- */
    var sgTier = 1;
    var sgBtn = document.getElementById('sgAtc');
    if(sgBtn){ sgTier = tierFromDom(sgBtn.closest('.bb') || pdpRoot); }
    function sgUpdate(){
      var btn = document.getElementById('sgAtc');
      if(!btn) return;
      var bump = document.getElementById('sgBumpChk');
      btn.textContent = 'Add to Cart — ' + fmt(SG_PRICES[sgTier] + (bump && bump.checked ? BOTTLE_PRICE : 0));
    }
    window.ezbSgTier = function(el,n){
      sgTier = n;
      el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
      el.classList.add('on');
      sgUpdate();
    };
    window.ezbSgAtc = function(){
      var btn = document.getElementById('sgAtc');
      var bump = document.getElementById('sgBumpChk');
      if(drawerReady() && window.PRODUCTS && window.PRODUCTS.supergreen){
        var p = window.PRODUCTS.supergreen, t = p.tiers[sgTier-1];
        window.cart = window.cart.filter(function(l){ return l.id!=='supergreen' || !l.fixed; });
        window.cart.push({key:'supergreen-tier', id:'supergreen', title:p.title, img:p.img,
          label:t.label+(t.offer?' · '+t.offer:''),
          qty:sgTier, minQty:sgTier, unit:t.price/sgTier, wasU:t.was?t.was/sgTier:null, total:t.price, fixed:true});
        if(bump && bump.checked && typeof window.cartAddUnit==='function') window.cartAddUnit('bottle');
        window.openCart(); window.renderCart();
        return;
      }
      var items = [{id: CFG.supergreen && CFG.supergreen.id, quantity: sgTier}];
      if(bump && bump.checked && CFG.bottle && CFG.bottle.id) items.push({id: CFG.bottle.id, quantity: 1});
      cartAdd(items, btn);
    };

    /* ----- BUNDLE & SAVE BUILDER ----- */
    var bpTier = 2, bSlots = [null,null,null];
    var bpBox = document.getElementById('bpSlots');
    if(bpBox) bpTier = tierFromDom(bpBox.closest('.bb'));
    window.ezbBpTier = function(el,n){
      bpTier = n;
      el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
      el.classList.add('on');
      renderBpSlots();
    };
    window.ezbBpSlot = function(i){
      pickCtx = 'bp'; bpModalSlot = i;
      openModal('Select the flavor for Bundle '+(i+1), bSlots[i]);
    };
    function renderBpSlots(){
      var wrap = document.getElementById('bpSlots');
      if(!wrap) return;
      wrap.querySelectorAll('.slot').forEach(function(s,i){
        s.style.display = i < bpTier ? 'flex' : 'none';
        var f = bSlots[i];
        if(f){
          var fo = FLAVORS.filter(function(x){ return x.name===f; })[0];
          s.classList.add('filled');
          s.innerHTML = '<img style="width:52px;height:52px;border-radius:11px;object-fit:cover" src="'+fo.img+'" alt="'+f+'"><b>'+f+'</b><span class="slot-progress">1/1 ✓ · tap to change</span>';
        } else {
          s.classList.remove('filled');
          s.innerHTML = '<span class="plus">+</span><span style="font-size:.72rem">Bundle '+(i+1)+' flavor</span><span class="slot-progress" style="color:var(--text)">0/1</span>';
        }
      });
      var filled = bSlots.slice(0,bpTier).filter(Boolean).length;
      var btn = document.getElementById('bpAtc');
      if(!btn) return;
      if(filled < bpTier){ btn.disabled = true; btn.textContent = ezbLabel(UI.atcSelect, bpTier, 'Select your flavors')+' ('+filled+'/'+bpTier+')'; }
      else { btn.disabled = false; btn.textContent = ezbLabel(UI.atcAdd, bpTier, 'Add '+bpTier+' Bundle'+(bpTier>1?'s':'')+' to Cart')+' — '+fmt(BP_PRICES[bpTier]); }
    }
    window.ezbBpAtc = function(){
      var btn = document.getElementById('bpAtc');
      if(!btn || btn.disabled) return;
      var chosen = bSlots.slice(0,bpTier);
      if(drawerReady() && window.BP_PRICES){
        var t = window.BP_PRICES[bpTier];
        window.cart = window.cart.filter(function(l){ return l.bundle!=='bp'; });
        window.cart.push({key:'bp-tier', id:'bundlekit', bundle:'bp', fixed:true, title:'Original + Flavored Bundle',
          img:(window.IMG && window.IMG.bundle) || '',
          label:t.label+' · Flavors: '+chosen.join(', ')+' · '+bpTier+'× Original', flavors:chosen.slice(),
          qty:bpTier, minQty:bpTier, unit:t.p/bpTier, wasU:(bpTier>1?49.98:null), total:t.p});
        window.cart.push({key:'bp-bottle', id:'bottle', bundle:'bp', gift:true, fixed:true, title:'Energyze Shaker Bottle',
          img:(window.IMG && window.IMG.bottle) || '', label:'FREE with every bundle', qty:1, total:0, was:11.99});
        window.openCart(); window.renderCart();
        return;
      }
      var counts = {};
      chosen.forEach(function(f){ counts[f] = (counts[f]||0)+1; });
      var items = Object.keys(counts).map(function(f){ return {id: variantForFlavor(f), quantity: counts[f]}; });
      items.push({id: CFG.original && CFG.original.id, quantity: bpTier});
      /* The bottle is advertised as "FREE with every bundle", but CFG.bottle is the
         paid $11.99 variant: adding it here billed 86.96 against a 75.00 button.
         This store has no $0.00 gift bottle product to point at, so the line is
         omitted rather than charged. Create one to restore the perk. */
      cartAdd(items, btn);
    };

    /* bump checkboxes re-total the ATC buttons */
    window.ezbPdpUpdate = function(){ renderFlavSlots(); origUpdate(); sgUpdate(); };

    /* initial paint */
    renderFlavSlots();
    renderBpSlots();
    origUpdate();
    sgUpdate();

    /* sticky add-to-cart bar: mirrors the main ATC, appears when it scrolls out of view */
    var mainAtc = document.getElementById('flavAtc') || document.getElementById('origAtc') || document.getElementById('sgAtc') || document.getElementById('bpAtc');
    if(mainAtc && 'IntersectionObserver' in window){
      var sbar = document.createElement('div');
      sbar.className = 'ezb ezb-sticky-atc';
      var sbtn = document.createElement('button');
      sbtn.className = 'btn btn--wide';
      sbtn.textContent = mainAtc.textContent;
      sbar.appendChild(sbtn);
      document.body.appendChild(sbar);
      sbtn.addEventListener('click', function(){
        if(mainAtc.disabled){ mainAtc.scrollIntoView({behavior:'smooth', block:'center'}); return; }
        mainAtc.click();
      });
      new MutationObserver(function(){ sbtn.textContent = mainAtc.textContent; })
        .observe(mainAtc, {childList:true, characterData:true, subtree:true});
      new IntersectionObserver(function(es){
        es.forEach(function(e){ sbar.classList.toggle('show', !e.isIntersecting); });
      }, {threshold: 0}).observe(mainAtc);
    }
  });
})();
